import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetGiftCardBalance } from '../../services/GiftCardService';
import { contactBackBff } from '../../../src/config/paths';

export const getBalance = createAsyncThunk(
  'giftCard/getBalance',
  async (params) => {
    const { giftCardNumber, reCaptchaToken } = params;
    const response = await callGetGiftCardBalance(
      giftCardNumber,
      reCaptchaToken,
      contactBackBff,
    );
    return response.data;
  },
);
